<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <h4 class="card-title">
          New AddressBook Entry
        </h4>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-sm-12">
        <div class="card">
          <form class="form-horizontal" @submit.prevent="handleSubmit">
            <div class="card-body card-blue">
              <div class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="public_key">Address Type
                  <span class="required text-danger">*</span>
                </label>
                <div class="col-sm-5">
                  <select id="address_type" v-model="entry.address_type" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('address_type')}" class="form-control" data-vv-as="Address Type" name="address_type">
                    <option :value="null">
                      Select Address Type
                    </option>
                    <option v-for="address_type in address_types" :key="address_type" :value="address_type">
                      {{ address_type }}
                    </option>
                  </select>
                  <div v-if="submitted && errors.has('address_type')" class="invalid-feedback">
                    {{ errors.first('address_type') }}
                  </div>
                </div>
              </div>

              <div v-if="entry.address_type" class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="name">Entry Name
                  <span class="required text-danger">*</span>
                </label>
                <div class="col-sm-5">
                  <input id="name" v-model="entry.name" v-validate="'required'" :class="{'is-invalid': submitted && errors.has('name')}" class="form-control" data-vv-as="Name" name="name" placeholder="Entry Name" type="text">
                  <div v-if="submitted && errors.has('name')" class="invalid-feedback">
                    {{ errors.first('name') }}
                  </div>
                </div>
              </div>

              <div v-if="entry.address_type" class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="description">Description</label>
                <div class="col-sm-5">
                  <input id="description" v-model="entry.description" :class="{'is-invalid': submitted && errors.has('description')}" class="form-control" data-vv-as="Description" name="description" placeholder="Description" type="text">
                  <div v-if="submitted && errors.has('description')" class="invalid-feedback">
                    {{ errors.first('description') }}
                  </div>
                </div>
              </div>

              <div v-if="entry.address_type=='Group' || entry.address_type=='Account'" class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="public_key">Public Key
                  <span class="required text-danger">*</span>
                </label>
                <div class="col-sm-5">
                  <input id="public_key" v-model="entry.public_key" v-validate="'required|duplicate_public_key'" :class="{'is-invalid': submitted && errors.has('public_key')}" class="form-control" data-vv-as="Public Key" name="public_key" placeholder="Public Key" type="text">
                  <div v-if="submitted && errors.has('public_key')" class="invalid-feedback">
                    {{ errors.first('public_key') }}
                  </div>
                </div>
              </div>

              <div v-if="entry.address_type=='Group'" class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="group_id">Group ID
                  <span class="required text-danger">*</span>
                </label>
                <div class="col-sm-5">
                  <input id="group_id" v-model="entry.group_id" v-validate="'required'" class="form-control" name="group_id" placeholder="Group ID" type="number">
                  <div v-if="submitted && errors.has('group_id')" class="invalid-feedback">
                    {{ errors.first('group_id') }}
                  </div>
                </div>
              </div>

              <div v-if="entry.address_type=='Did'" class="form-group row">
                <label class="col-sm-3 text-right control-label col-form-label" for="did">DID
                  <span class="required text-danger">*</span>
                </label>
                <div class="col-sm-5">
                  <input id="did" v-model="entry.did" v-validate="'required|duplicate_did'" class="form-control" name="did" placeholder="DID" type="text">
                  <div v-if="submitted && errors.has('did')" class="invalid-feedback">
                    {{ errors.first('did') }}
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <div class="form-group m-b-0 text-right">
                <div class="button-group">
                  <button class="btn waves-effect waves-light btn-success" type="submit">
                    Save
                  </button>
                  <button class="btn waves-effect waves-light btn-secondary" type="button" @click="reset()">
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import { Validator } from 'vee-validate'

export default {
  name: 'NewAddressBookEntry',
  data () {
    return {
      isLoading: false,
      registries: [],
      address_types: ['Account', 'Group', 'Did'],
      submitted: false,
      entry: {
        address_type: null,
        name: null,
        description: null,
        public_key: null,
        group_id: null,
        did: null
      }
    }
  },
  computed: {
    ...mapGetters(['userAddressBook', 'userAddressBookItem'])
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      Validator.extend('duplicate_public_key', {
        getMessage: () => 'This public key already exists in the addressbook.',
        validate: () => !this.userAddressBook.some(entry => entry.public_key == this.entry.public_key)
      })

      Validator.extend('duplicate_did', {
        getMessage: () => 'This did already exists in the addressbook.',
        validate: () => !this.userAddressBook.some(entry => entry.did == this.entry.did)
      })
    },
    handleSubmit () {
      this.submitted = true

      // TODO: automatically get group_id from public key? or public_key from group_id?

      // TODO: for duplicates allow overwrite option? Take user to edit page?

      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.save()
          }
        })
    },
    async save () {
      try {
        this.entry.group_id = parseInt(this.entry.group_id)

        const { data } = await this.$accounts.post('/addressbook/user', this.entry)
        this.entry.address_book_entry = data.address_book_entry_db
        Vue.set(this.userAddressBook, this.userAddressBook.length, this.entry)
        this.$toastr.s('Address Book Entry created', 'Success!')
        this.$router.go(-1)
      } catch (e) {
        this.$toastr.e('Address Book Entry creation failed', 'Failed!')
      } finally {
        this.submitted = false
      }
    },
    reset () {
      this.entry = {
        address_type: null,
        name: null,
        description: null,
        public_key: null,
        group_id: null,
        did: null
      }
    }
  }
}
</script>

<style scoped>
</style>
